import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

interface Props {
    label: string;
}

const MetaDataItem = ({ label, children }: React.PropsWithChildren<Props>) => {
    return (
        <Stack gap={0.5}>
            <Typography fontSize="12px" color="#424853" whiteSpace="nowrap">
                {label}
            </Typography>
            <Typography fontSize="14px" fontWeight="600" lineHeight="14px">
                {children || <Skeleton />}
            </Typography>
        </Stack>
    );
};

export default MetaDataItem;
